import {ComponentType} from 'react';
import loadable from '../../../../utils/loadable';
import {AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION} from '../../../../modules/common/consts';

const GlobalKpiEditorWrapper: ComponentType<unknown> = loadable({
	loader: () => import('../../../../modules/dataprocessingdefinitions/global/GlobalKpiEditorPage')
});
export default {
	relativePath: 'create',
	component: GlobalKpiEditorWrapper,
	requiredAuthorities: [AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION]
};
